'use strict'; // TODO: Remove from `core-js@4`

var ArrayBufferViewCore = require('../internals/array-buffer-view-core');

var $filterReject = require('../internals/array-iteration').filterReject;

var fromSpeciesAndList = require('../internals/typed-array-from-species-and-list');

var aTypedArray = ArrayBufferViewCore.aTypedArray;
var exportTypedArrayMethod = ArrayBufferViewCore.exportTypedArrayMethod; // `%TypedArray%.prototype.filterOut` method
// https://github.com/tc39/proposal-array-filtering

exportTypedArrayMethod('filterOut', function filterOut(callbackfn
/* , thisArg */
) {
  var list = $filterReject(aTypedArray(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  return fromSpeciesAndList(this, list);
}, true);